export enum EMortgageAnnotationHeightPercent {
  Default = 6,
  Half = Default / 2,
  Double = Default * 2,
}

export enum EMortgageAnnotationHeightPercentDecimal {
  Default = EMortgageAnnotationHeightPercent.Default / 100,
  Half = EMortgageAnnotationHeightPercent.Half / 100,
  Double = EMortgageAnnotationHeightPercent.Double / 100,
}
